module.exports = __webpack_public_path__ + "img/cloud-file.a22704ce.svg";